import React, { useState } from 'react';
import cx from 'classnames';

const ImageSelection = ({ options, handleSelection, selectedOption, useAnimation, animatedOptions, useHover }) => {

  return (
    <div className="imageSelection">
      {options.map(option => {
        const formattedImageUrl = option.imageUrl.replace("s3.amazonaws.com/amira-assets",process.env.ASSET_ROOT);
        return (
          <div
            className={cx("imageBox", {
              willAnimate: useAnimation,
              animate: animatedOptions.includes(option.key),
              selected: selectedOption === option.key,
              useHover: useHover
            })}
            key={option.key}
          >
            <div className="answerBox">
              <img
                src={formattedImageUrl}
                alt={`Option ${option.key}`}
                onClick={() => handleSelection(option.key)}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ImageSelection;